<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <button type="button" class="in_back_btn" @click="$router.replace('/')">
                    <img src="@/assets/user/line_back_ico_l.png" alt="">
                    <span>BACK</span>
                </button>
                <p class="page_title"> 스트레스 케어 </p>
                <div class="stress_category">
                    <router-link to="#" @click="showCategoryContents('0')">
                        <img src="@/assets/user/cate1.png" alt="">
                        <p>전체</p>
                    </router-link>
                    <router-link to="#" @click="showCategoryContents(state.category[0].idx)">
                        <img src="@/assets/user/cate5.png" alt="">
                        <p>{{ state.category[0]?.name }}</p>
                    </router-link>
                    <router-link to="#" @click="showCategoryContents(state.category[1].idx)">
                        <img src="@/assets/user/cate2.png" alt="">
                        <p>{{ state.category[1]?.name }}</p>
                    </router-link>
                    <router-link to="#" @click="showCategoryContents(state.category[2].idx)">
                        <img src="@/assets/user/cate3.png" alt="">
                        <p>{{ state.category[2]?.name }}</p>
                    </router-link>
                    <router-link to="#" @click="showCategoryContents(state.category[3].idx)">
                        <img src="@/assets/user/cate4.png" alt="">
                        <p>{{ state.category[3]?.name }}</p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="state.modalContent" @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import { HeaderLayout, GnbLayout, ModalComponent, reactive, apiService, res, onMounted, router } from "@/BaseComponent";
export default {
    components: {
        HeaderLayout,
        GnbLayout,
        ModalComponent,
    },
    setup() {
        const state = reactive({
            category: [] as any,
            modalContent: "" as string,
            isModalOpen: false as boolean,
        });

        onMounted(() => {
            getCategory();
        });

        const getCategory = async () => {
            let res: res = await apiService.stressCare.getCategory();
            if (res.returnCode === 0) {
                state.category = res.list;
            } else {
                state.modalContent = res.description;
                state.isModalOpen = true;
            }
        };
        const showCategoryContents = (categoryIdx: string) => {
            router.push({
                name: `stressCareList`,
                state: { categoryIdx: categoryIdx },
            });
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
        };
        return {
            state,
            showCategoryContents,
            modalClose,
        };
    },
};
</script>
